// extracted by mini-css-extract-plugin
var _1 = "EntityExtraTagsItemStatuses-modulestatuses__cNaQ1";
export { _1 as "statuses" }
